import { unminifyError } from '@sgme/stacktrace';
import { documentApi } from 'apiConnector/document/document';
import { useUserNotification } from 'hooks/useUserNotification';
import type { BlobFileResponse } from 'models/FileResponse';
import { useCallback, useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadFile } from 'utils/documents/downloadDocument';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

export const useDownloadDlpDocument = (errorMessage: string) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const userNotification = useUserNotification();

  const downloadDlpDocument = useCallback(
    (token: string) => {
      setIsDownloading(true);

      const dlpDocument$: Observable<BlobFileResponse> = documentApi.downloadDocumentByDocumentToken(token).pipe(
        finalize(() => {
          setIsDownloading(false);
        }),
      );
      dlpDocument$.subscribe({
        next({ data, filename }: BlobFileResponse) {
          downloadFile(data, filename);
        },
        async error(err: Error) {
          const e = await unminifyError(err);
          getFrontLogger().error('Failure to download DLP document {@FrontError}', e);
          userNotification.error({ title: { id: 'toast.termsheet' }, content: [errorMessage] });
          setError(errorMessage);
        },
      });
    },
    [userNotification, errorMessage],
  );

  return {
    isDownloading,
    error,
    downloadDlpDocument,
  };
};
